import { odata } from '../../conf';
import Actions from '../../odata/actions';

const actions = new Actions('productGroup', 'productGroups');

const customActions = {
  async LOAD_productGroups({ commit, rootGetters }) {
    const data = await odata.o(rootGetters)
      .get('productGroups')
      .query({ $filter: 'IsDeleted eq false', $orderBy: 'DisplayOrder' });
    commit('SET_productGroups', data);

    return data;
  },
};

export default { ...actions, ...customActions };
